/**
 * First view in the MFA activation flow. 
 * Options: totp_uri, validation_token
 * Currently supports application auth only
 */
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/mfa/dialog-mfa-select.hbs';
import MFAValidateDialog from '@/views/dialogs/validate_mfa';

var globalCh = Radio.channel('global');

var view = Marionette.View.extend(DialogInterface).extend({
    id: 'enable-mfa-dialog',
    template: Handlebars.compile(template),
    ui: {
        checkbox: 'input[type="checkbox"]',
        form: 'form',
        submit_btn: '.btn.btn-primary',
    },
    initialize: function (options) {
        this.destroyOnClose();
        this.focusFirstInput();
    },
    events: {
        'submit form': 'onSubmit',
        'keyup' : function(e) {
            if (e.keyCode === 13) {
                this.onSubmit(e);
            }
        }
    },
    onSubmit: function (event) {
        event.preventDefault();
        var self = this;
        var fields = this.ui.form.serializeArray();

        if (fields.length < 1) {
            self.showAlert('error', 'Please select an authentication method');
            return;
        }

        // Launch auth confirm
        var view = new MFAValidateDialog({
            model: self.model,
            totp_delivery: fields, // Selected totp delivery method, to be used later
            title: 'Verify your password',
            description: 'To enable Multi-Factor Authentication, please verify your current password.'
        });
        globalCh.request('showDialog', view);
    },
});

export default view;

